<template>
    <div style="height: 100%;">
        <div class="bottom-bar">
            <!-- <hr /> -->
            <div class="bottom-bar-row">
                <div class="div-total">
                    <h4>Total:</h4>
                    <p>R$ {{ valorFinalTotal }}</p>
                </div>

                <button  v-if="getDeliveryValorMinimoPodeEnviar == false" class='btn-desabilitado' @click="mostrarMensagemPedidoMinomo()">
                    <!-- <img src="../../assets/icons/ic-check.png" alt="" /> -->
                    <p>Pedido mínimo: R$ {{ deliveryValorMinimo }}</p>
                </button>
            

                <button v-if="getDeliveryValorMinimoPodeEnviar == true" :class="[podeEnviar ? 'btn-verde' : 'btn-desabilitado']" @click="[podeEnviar ? onClickConfirmar() : funcaoAnimarTextoDesabilidado()]">
                    <img src="../../assets/icons/ic-check2.png" alt="" />
                    <p>ENVIAR PEDIDO</p>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
    name: "BottomBarCarrinho",
    components: {
    },
    data() {
        return {
            isDelivery: this.$store.state.tipoCardapio === 'delivery',
            deliveryValorMinimo: this.$store.state.deliveryValorMinimo,
        }
    },
    computed: {
        getValorFinalEmNumero() {
            return Number(this.valorFinalTotal.replace(",", "."))
        },
        getDeliveryValorMinimoPodeEnviar() {
            if (this.deliveryValorMinimo == null || this.deliveryValorMinimo == undefined) {
                return true
            } else
            if (Number(this.deliveryValorMinimo) == 0.0) {
                return true
            } else 
            if (Number(this.deliveryValorMinimo) > Number(this.getValorFinalEmNumero)) {
                return false
            } else
            return true;
        }
    },
    methods: {
        mostrarMensagemPedidoMinomo() {
            Swal.fire({
                title: "O valor mínimo do pedido deve ser de R$" + this.deliveryValorMinimo + ",00"
            })
        }
    },
    props: {
        podeEnviar: Boolean,
        valorFinalTotal: undefined,
        onClickConfirmar: Function,
    }
}
</script>

<style scoped>
.bottom-bar {
    background: var(--cinza-claro);
    border-top: 1px var(--cinza-escuro) solid;
    padding: var(--padding-padrao);
    height: 100%;
}
.div-total{
    color: darkblue;
    align-items: center;
}
.div-total>p{
    font-size: 24px;
}
.bottom-bar-row {
    width: 100%;
    display: flex;
}
.bottom-bar-row > div {
    width: 100%;
    display: flex;
}
.bottom-bar-row > div > h4 {
    font-weight: bold;
    color: var(--primaryDark_azul);
    font-size: 14px;
    margin: 0px;
}
.bottom-bar-row > div > p {
    font-weight: bold;
}
.bottom-bar-row > button {
    width: 100%;
    height: 60px;
    justify-content: center;
}

</style>